export function convertToCSV(objArray) {
  if (!Array.isArray(objArray) || objArray.length === 0) return "";

  const headers = Object.keys(objArray[0]);
  const escape = (val) => {
    let str = val == null ? "" : String(val);
    if (str.includes('"')) str = str.replace(/"/g, '""');
    return `"${str}"`;
  };

  // Header row
  let csv = headers.map(escape).join(",") + "\r\n";

  // Data rows
  for (const row of objArray) {
    const line = headers.map((key) => escape(row[key])).join(",");
    csv += line + "\r\n";
  }

  return csv;
}

export function exportTransactionTypeDistributionCSV({
  chartData,
  storeName,
  range,
  fileName = "TransactionTypeDistribution.csv",
}) {
  if (!chartData || !chartData.labels || !chartData.datasets?.[0]?.data) {
    console.error("exportTransactionTypeDistributionCSV: invalid chartData");
    return;
  }

  // Determine date range label
  const from = range.tran_date.$lte?.split("T")[0] || "";
  const to = range.tran_date.$gte?.split("T")[0] || "";
  const dateRange = `${from} ${to}`;

  // Build rows
  const rows = chartData.labels.map((label, idx) => ({
    Brand: "Angels Pizza",
    Store: storeName || "All Stores",
    DateRange: dateRange,
    TransactionType: label,
    Count: chartData.datasets[0].data[idx] || 0,
  }));

  // Convert to CSV
  const csvString = convertToCSV(rows);
  if (!csvString) {
    console.warn("exportTransactionTypeDistributionCSV: no data to export");
    return;
  }

  // Trigger download
  const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
